import React from 'react';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';
import useStyles from './styles';

export default function AppBarWithTabs(props) {
  const {
    children,
    firstTabTitle,
    secondTabTitle,
    thirdTabTitle,
    firstTabName,
    secondTabName,
    thirdTabName,
    selectedTab,
  } = props;
  const classes = useStyles();

  const handleClickOnFirstTab = () => {
    props.setSelectedTab(firstTabName);
  };

  const handleClickOnSecondTab = () => {
    props.setSelectedTab(secondTabName);
  };
  const handleClickOnThirdTab = () => {
    props.setSelectedTab(thirdTabName);
  };

  return (
    <AppBar elevation={0} position="static" className={classes.appBar}>
      <Grid container spacing={0}>
        <Grid item xs={8}>
          <ButtonGroup className={classes.buttonGroup} variant="contained">
            <Button
              className={
                selectedTab === firstTabName
                  ? classes.selectedTab
                  : classes.notSelectedTab
              }
              onClick={handleClickOnFirstTab}
            >
              {firstTabTitle}
            </Button>
            <Button
              className={
                selectedTab === secondTabName
                  ? classes.selectedTab
                  : classes.notSelectedTab
              }
              onClick={handleClickOnSecondTab}
            >
              {secondTabTitle}
            </Button>
            {thirdTabTitle && thirdTabName && (
              <Button
                className={
                  selectedTab === thirdTabName
                    ? classes.selectedTab
                    : classes.notSelectedTab
                }
                onClick={handleClickOnThirdTab}
              >
                {thirdTabTitle}
              </Button>
            )}
          </ButtonGroup>
        </Grid>
        <Grid item xs={4}>
          {children}
        </Grid>
      </Grid>
    </AppBar>
  );
}
